<template>
    <section id="success">
        <!-- lottie confetti animation -->
        <!-- <div class="animation-img w-100" style="height: 100vh">
            <lottie-animation
                path="confetti-dark-theme.json"
                :loop="true"
                :autoPlay="true"
                :speed="1"
            />
        </div>        -->
        <b-modal 
            id="success-modal" 
            ref="successModal"
            @hide = "hideModal"
            centered
            hide-header hide-footer>
            <div class="d-flex justify-content-center align-items-center">
                <div class="popup-content text-center position-relative">
                    <button
                        @click="doAction"
                        aria-label="Close"
                        class="close pr-2"
                        id="close-button">
                            <CloseCross/>
                    </button>
                    <div class="p-5">
                        <Icon icon="bell"/>
                        <div class="heading my-5">
                            <h4 class="text">{{title}}</h4>
                            <h5 class="p2n my-4" v-if="subTitle">{{subTitle}}</h5>
                        </div>
                        <Button class="px-4 py-2 btn-purple" @click.native="doAction">{{btnText}}</Button>  
                    </div>
                </div>
            </div>
        </b-modal>
       
    </section>
</template>

<script>
import {mapState} from 'vuex'
import Icon from '../components/Theme/Icon'
import {CloseCross} from '../components/Icons'
import Button from '../components/Theme/Button'
import LottieAnimation from "lottie-vuejs/src/LottieAnimation.vue";
export default {
    data(){
        return {
            title: '',
            subTitle: '',
            btnText: '',
            url: '/'
        }
    },
    mounted() {
        this.title = this.modals['success-modal'].title
        this.subTitle = this.modals['success-modal'].subTitle 
        this.btnText = this.modals['success-modal'].btnText || 'Next'
        this.url = this.modals['success-modal'].url || '/'
        this.$bvModal.show(`success-modal`)
    },
    computed: {
        ...mapState(['modals']),
    },
    components: {
        Icon,
        CloseCross,
        Button,
        LottieAnimation
    },
    methods: {
        hideModal(){
            setTimeout(() => {
                this.$store.commit('TOGGLE_MODAL', ['success-modal', false]);
            }, 100)
            return this.$router.push(this.url).catch('/')
        },
        doAction(){
            this.$bvModal.hide('success-modal');
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '../assets/scss/variables';

    // styles for lottie animation 
    // .animation-img {
    //     height: 90vh;
    //     margin: 0 auto;
    //     min-width: 320px;
    //     display: block;
    //     width: 50vh;
    //     background-size: cover;
    //     position: absolute;
    //     top: 0;
    //     z-index: 1000000;
    // }

    .popup-content {
        background-color: #f4f4f4;
        max-width: 720px;
        width: 100%

        h5 {
            line-height: 24px;
        }
    }

    .text {
        font-size: $h4;
        font-weight: bold;
    }

    button[data-type="pricing-trial"] { 
        color: $c1;
        border: 1px solid $c1;
        font-weight: $weight_bold;
        font-size: 16px;
        border-radius: 5px;
        &:hover {
            background: $c1;
            color: $c14;
        }
    }

</style>